/* MO Motion — entrance choreography baseline (race-proof model).
   Nothing is hidden until layout is trustworthy (window load or first scroll);
   then only elements BELOW the live viewport are staged to reveal on approach.
   Above-fold content never blinks. Failsafe force-reveals after 6s.
   Off for prefers-reduced-motion / no-JS. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SELECTORS = [
    '.mo-display',
    '.mo-eyebrow',
    '.mo-body',
    '.mo-cessay__prose > p',
    '.mo-cessay__rule',
    '.mo-editorial p'
  ].join(',');

  var candidates = [];
  var pending = [];
  var qpending = [];
  var trusted = false;
  var ticking = false;

  function moTrack(name, params) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, params || {});
    } catch (e) {}
    try { if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, params || {})); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) {}
  }
  window.moTrack = window.moTrack || moTrack;

  function collectQP(scope) {
    (scope || document).querySelectorAll('.mo-hm-guide, [data-mo-lscroll], [data-mo-vscrub], .mo-cgraph, [data-mo-feelpress]').forEach(function (el) {
      if (el.dataset.moQp) return;
      el.dataset.moQp = '1';
      qpending.push(el);
    });
  }

  function collect(scope) {
    collectQP(scope);
    (scope || document).querySelectorAll(SELECTORS).forEach(function (el) {
      if (el.dataset.moRv) return;
      if (el.closest('header, footer, [id*="__header"], [id*="__footer"], .mo-lscroll__rail')) return;
      el.dataset.moRv = '1';
      if (trusted) stage(el); else candidates.push(el);
    });
  }

  function stage(el) {
    var r = el.getBoundingClientRect();
    if (r.top <= window.innerHeight) return; /* visible or above: leave untouched */
    el.classList.add('mo-rv');
    var section = el.closest('.shopify-section') || document.body;
    var key = section.id || 'root';
    stage.g = stage.g || {};
    stage.g[key] = (stage.g[key] || 0) + 1;
    el.style.transitionDelay = Math.min((stage.g[key] - 1) * 70, 420) + 'ms';
    pending.push(el);
  }

  function trust() {
    if (trusted) return;
    trusted = true;
    document.documentElement.classList.add('mo-motion-on');
    candidates.forEach(stage);
    candidates = [];
    /* stuck-checker: every 2.5s, force-reveal anything that is on screen yet
       still hidden (engine-failure protection) — below-fold staging untouched */
    setInterval(function () {
      if (!pending.length) return;
      var vh = window.innerHeight;
      pending = pending.filter(function (el) {
        if (el.getBoundingClientRect().top < vh) { el.classList.add('is-in'); return false; }
        return true;
      });
    }, 2500);
  }

  function sectionType(el) {
    if (el.classList.contains('mo-hm-guide')) return 'guidance';
    if (el.hasAttribute('data-mo-lscroll')) return 'layer_scroll';
    if (el.hasAttribute('data-mo-vscrub')) return el.dataset.loop === '1' ? 'video_loop' : 'video_scrub';
    if (el.classList.contains('mo-cgraph')) return 'cinemagraph';
    if (el.hasAttribute('data-mo-feelpress')) return 'feel_press';
    return 'unknown';
  }

  function check() {
    ticking = false;
    var vh = window.innerHeight;
    if (qpending.length) {
      qpending = qpending.filter(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.8 && r.bottom > 0) {
          el.classList.add('is-qp');
          moTrack('mo_motion_view', { section_type: sectionType(el), page: location.pathname });
          return false;
        }
        return true;
      });
    }
    if (!pending.length) return;
    pending = pending.filter(function (el) {
      if (el.getBoundingClientRect().top < vh * 0.92) {
        el.classList.add('is-in');
        return false;
      }
      return true;
    });
  }
  function onScroll() {
    if (!trusted) trust();
    if (!ticking) { ticking = true; requestAnimationFrame(check); }
  }

  function boot() {
    collect();
    if (document.readyState === 'complete') trust();
    else window.addEventListener('load', trust, { once: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) { collect(e.target); });
})();
